import { computed, ref } from 'vue';
import {
  emailReg,
  isPhoneNumberValid,
  normalizePhoneNumber,
} from 'src/utils/base';
import { use18n, useIns } from 'src/utils/v2_helper/common';

/**
 * 补充用户信息的自定义钩子
 * 用于OTP关闭并且未登录时管理用户信息表单的填写状态和验证逻辑
 */
export function useFillInfo() {
  const { $t } = use18n();
  const app = useIns();
  // 初始化表单数据结构
  const fillForm = ref({
    nickName: '',
    email: '',
    phone: '',
  });

  // 创建表单字段的引用，用于错误时聚焦字段
  const fillFieldRefs = {
    nickName: ref(),
    email: ref(),
    phone: ref(),
  };

  // 游客显示补充用户信息表单
  const showFillForm = computed(() => app.userInfo.guestUser)

  // 字段校验规则
  const invalidFillPhoneErrMsg = computed(() => {
    if (app.phoneOptional && !fillForm.value.phone) return '';
    if (!isPhoneNumberValid(fillForm.value.phone)) return $t('checkout.phoneNumberInvalid');
    return '';
  });
  const invalidFillNameErrMsg = computed(() => {
    if (!app.nameOptional && !fillForm.value.nickName) return $t('checkout.requiredNameTip');
    return '';
  });
  const invalidFillEmailErrMsg = computed(() => {
    if (app.emailOptional && !fillForm.value.email) return '';
    if (!fillForm.value.email) return $t('checkout.requiredEmailTip');
    if (!emailReg.test(fillForm.value.email)) return $t('checkout.EmailInvalid');
    return '';
  });
  // 计算得到表单验证错误的队列
  const fillFormInvalidQueue = computed(() => [
    { field: 'nickName', msg: invalidFillNameErrMsg.value, el: fillFieldRefs.nickName.value?.el },
    { field: 'email', msg: invalidFillEmailErrMsg.value, el: fillFieldRefs.email.value?.el },
    { field: 'phone', msg: invalidFillPhoneErrMsg.value, el: fillFieldRefs.phone.value?.el },
  ].filter(item => item.msg));

  // 表单是否校验成功
  const fillFormValid = computed(() => fillFormInvalidQueue.value.length === 0);
  // 表单配置项
  const formListConfig = computed(() => [
    { label: $t('fullDinein.name'), prop: 'nickName', ref: fillFieldRefs.nickName, required: !app.nameOptional, max: 254, placeholder: $t('checkout.namePlaceholder'), errMsg: invalidFillNameErrMsg },
    { label: $t('checkout.Email'), prop: 'email', ref: fillFieldRefs.email, required: !app.emailOptional, max: 254, placeholder: $t('checkout.emailPlaceholder'), errMsg: invalidFillEmailErrMsg },
    { label: $t('checkout.phoneNumber'), prop: 'phone', ref: fillFieldRefs.phone, required: !app.phoneOptional, max: 30, placeholder: $t('checkout.phoneNumberPlaceholder'), filter: normalizePhoneNumber, errMsg: invalidFillPhoneErrMsg },
  ])
  return {
    fillForm,
    fillFieldRefs,
    showFillForm,
    invalidFillNameErrMsg,
    invalidFillEmailErrMsg,
    invalidFillPhoneErrMsg,
    fillFormInvalidQueue,
    fillFormValid,
    formListConfig,
  };
}
